import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormArray, FormGroup, AbstractControl } from '@angular/forms';
import { Observable, throwError, merge } from 'rxjs';
import { map, distinct, mapTo, catchError, delay, retry } from 'rxjs/operators';
import { Event, Partner } from '@app/shared/_models/common';
import { EMPTY, empty, of } from "rxjs";

import { Product, ProductTpl } from '@app/shared/_models/product';
import { ScanResult } from '@app/shared/_models/scan';
import * as constants from "@app/shared/constants";

import { environment } from '../../../environments/environment';

export interface ProductFilter {
	name?: string;
	manuf?: number;
	minprice?: number;
	maxprice?: number;
	limit?: number;
	product_id?: number;
	template_id?: number;
	cufs?: Record<string, string>;
	is_sold?: boolean;      // absent = vendables et non vendables
	is_purchased?: boolean; // absent = achetables et non achetables
	ean?: string;
	refsup?: string;
}

@Injectable({
	providedIn: 'root'
})

export class ProductsService {

	constructor(private http: HttpClient) { }

	getProductsTplByFilterAsFormArray(filter: ProductFilter): Observable<FormArray> {
		debugger; // Execution stops here
		return this.getProductsTplByFilter(filter).pipe(map((productTpls: ProductTpl[]) => {
			// console.log("fgs: " + JSON.stringify(productTpls));
			const fgs: FormArray = new FormArray(productTpls.map((productTpl) => ProductTpl.asFormGroup(productTpl)));
			return fgs;
		}));
	}
	getProductsTplByFilter(filter: ProductFilter): Observable<any> {
		// let q:String = "q=cuf:5";   // only for users that need lpp
		let filtres: [string, string][] = [];
		if (filter.cufs) {
			for (const [key, value] of Object.entries(filter.cufs)) {
				filtres.push(['cuf_' + key, value]);
			}
		}
		console.log('filtres', filtres);
		if (filter.product_id) {
			filtres.push(['product_id', filter.product_id.toString()]);
		} else {
			if (filter.name?.trim()) { filtres.push(['name', filter.name]) }
			if (filter.manuf) { filtres.push(['manuf', filter.manuf.toString()]) }
			if (filter.template_id) { filtres.push(['template_id', filter.template_id.toString()]) }
			if (filter.minprice) { filtres.push(['minprice', filter.minprice.toString()]) }
			if (filter.maxprice) { filtres.push(['maxprice', filter.maxprice.toString()]) }
			if (filter.is_sold != null) { filtres.push(['is_sold', String(filter.is_sold)]) }
			if (filter.is_purchased != null) { filtres.push(['is_purchased', String(filter.is_purchased)]) }
			// Encodés : une référence peut porter « + », « & » ou « # », qui couperaient la query string.
			if (filter.ean?.trim()) { filtres.push(['ean', encodeURIComponent(filter.ean.trim())]) }
			if (filter.refsup?.trim()) { filtres.push(['refsup', encodeURIComponent(filter.refsup.trim())]) }
			if (filter.limit) { filtres.push(['limit', Math.round(filter.limit).toString()]) }
		}

		if (filtres.length == 0) return EMPTY;
		let q = "q=" + filtres.map(([key, value]) => `${key}:${value}`).join(' AND ');
		console.log("q: " + q);


		return this.http.get<void>(environment.server_url + "/productstpl?" + q + '&o=cuf_5')
		// return this.http.get<void>(environment.server_url + "/productstpl?" + q ).pipe(delay(1500));  // FOR DEV  on ralenti la réponse pour voir le spinner et comprendre les interaction 
	}

	getProductById(id: number) { // TODO REMOVE ME
		return this.http.get<void>(environment.server_url + "/product/" + id);
	}

	getProductsByFilter(typ: string, q: string, options: String) {
		return this.http.get<void>(environment.server_url + "/products?typ=" + typ + "&q=" + q + options);
	}

	search_i(q: string) { // return and array of array with 3 vals [ product id , name, template_id ]
		q = "?q=" + q;
		return this.http.get<string[][]>(environment.server_url + "/search/i" + q);
	}

	search_manuf(q: string) {
		q = "?q=" + q;
		return this.http.get<void>(environment.server_url + "/search/manuf" + q);
	}

	// // plus utilisé a été remplacé par  search_productpackaging qui est plus complète et il ne faut pas trop augmenter les endpoit côté api
	// search_bc(q: string): Observable<any> {
	// 	if (parseInt(q) !== +q) return of(null);  // Not a number => do not call barcode API
	// 	q = "?q=" + q;
	// 	return this.http.get<void>(environment.server_url + "/search/bc" + q);
	// }		

	// Index Redis jpid:{produit} : le conditionnement PAR DÉFAUT d'un produit, seul chemin qui calcule le tarif client.
	// Une lecture de code-barres ne passe plus par ici (index jbc) mais par search_scan.
	search_productpackaging(index: string, key: number, pricelists: number[] | undefined = undefined): Observable<any> {
		let params = "?index=" + index + "&key=" + key + (pricelists ? '&pricelists=' + pricelists : '');
		return this.http.get<void>(environment.server_url + "/search/productpackaging" + params);
	}

	// GET /search/scan : la lecture brute (EAN, GS1-128/DataMatrix/QR, Digital Link, HIBC, code interne…) est décodée par le serveur,
	// qui rend { scan, key, ppv }. encodeURIComponent obligatoire : GS → %1D, « + » d'un HIBC → %2B (un « & » nu = 400).
	search_scan(raw: string, pricelists: number[] | undefined = undefined, aim: string | undefined = undefined): Observable<ScanResult> {
		let params = "?raw=" + encodeURIComponent(raw) + (aim ? '&aim=' + encodeURIComponent(aim) : '') + (pricelists ? '&pricelists=' + pricelists : '');
		return this.http.get<ScanResult>(environment.server_url + "/search/scan" + params);
	}

	// Id du conditionnement par défaut d'un produit : toute ligne de vente en désigne un, même quand l'utilisateur
	// n'a pas choisi (composant de configuration, vente additionnelle, location). Ne lève jamais : undefined à défaut.
	default_ppv_id(product_id: number | undefined): Observable<number | undefined> {
		if (!product_id) return of(undefined);
		return this.search_productpackaging('jpid', product_id).pipe(
			map((ppv: any) => ppv?.id ?? undefined),
			catchError(() => of(undefined)),
		);
	}

	postProducts(variants: any): Observable<any> {
		return this.http.post<any>(environment.server_url + "/products", variants, { 'headers': constants.jsonheader });
	}
}
